// @flow
import React, { Component, Fragment, createContext } from 'react';
import type { Node } from 'react';
import NotificationRender from './NotificationRender';
import type { NotificationProps } from './NotificationRender';

const Context = createContext({});

type Props = Node;
type State = {
  currentNotification: ?Node,
  open: boolean,
};
export type Notification = {
  persitent: ?boolean,
} & NotificationProps;

export class NotificationsProvider extends Component<Props, State> {
  state = {
    currentNotification: null,
    open: false,
  };

  queue = [];
  intervalTime = 3000;
  intervalId = null;

  addNotification = (notification: Notification) => {
    const id = new Date().getTime();
    this.queue.push({ ...notification, id });
    this.startPolling();
    return id;
  };

  removeNotification = (id: number) => {
    this.queue = this.queue.filter(n => n.id !== id);
    if (this.state.currentNotification.id === id) {
      this.next();
    }
  };

  startPolling = () => {
    if (this.intervalId === null) {
      this.processQueue();
      this.intervalId = setInterval(() => {
        this.processQueue();
      }, this.intervalTime);
    }
  };

  stopPolling = () => {
    if (this.intervalId === null) return;
    clearInterval(this.intervalId);
    this.intervalId = null;
  };

  next = () => {
    this.stopPolling();
    this.startPolling();
  };

  dismiss = () => this.next();

  processQueue = () => {
    if (this.queue.length > 0) {
      this.setState({
        currentNotification: this.queue.shift(),
        open: true,
      });
    } else {
      this.stopPolling();
      this.setState({ open: false });
    }
  };

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ open: false });
  };

  handleExited = () => {
    this.processQueue();
  };

  getContext = () => {
    const { queue: notifications } = this;
    const { addNotification, removeNotification, dismiss } = this;
    return { notifications, addNotification, removeNotification, dismiss };
  };

  render() {
    const { children } = this.props;
    const { currentNotification } = this.state;
    return (
      <Context.Provider value={this.getContext()}>
        {currentNotification && (
          <NotificationRender
            {...currentNotification}
            key={currentNotification.id}
            open={this.state.open}
            onClose={this.handleClose}
            onExited={this.handleExited}
          />
        )}
        <Fragment>{children}</Fragment>
      </Context.Provider>
    );
  }
}

export const NotificationsConsumer = Context.Consumer;



// WEBPACK FOOTER //
// /opt/build/repo/src/packages/notifications/components/NotificationsProvider.js